import React from "react";
import { useTheme } from "@emotion/react";
import {
  Backdrop,
  CircularProgress,
  Container,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import * as Yup from "yup";
import RadioButtonComponent from "../../components/forms/RadioButtonComponent";
import Form from "../../components/forms/Form";
import InputComponent from "../../components/forms/InputComponent";
import SubmitButton from "../../components/forms/SubmitButton";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getStore, updateStore } from "../../actions/storeActions";
import { STORE_UPDATE_RESET } from "../../constants/storeConstants";

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .min(3, "Name must be at least 3 characters"),
  status: Yup.boolean().required("status is required"),
});

const EditStore = () => {
  const dispatch = useDispatch();

  const { palette } = useTheme();
  const navigate = useNavigate();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const storeUpdate = useSelector((state) => state.storeUpdate);
  const { loading, error, success } = storeUpdate;

  const storeGet = useSelector((state) => state.storeGet);
  const {
    loading: loadingGet,
    error: errorGet,
    success: successGet,
    store,
  } = storeGet;

  const params = useParams();

  useEffect(() => {
    if (!userInfo) {
      navigate("/", { replace: true });
    }

    if (params.id) {
      dispatch(getStore(params.id));
    }

    if (success) {
      navigate("/store");
      toast("Store updated successfully");
      dispatch({ type: STORE_UPDATE_RESET });
    }
  }, [userInfo, dispatch, navigate, success, params.id]);

  const handleSubmit = ({ name, status }) => {
    dispatch(updateStore({ _id: params.id, name, status }));
  };

  return (
    <Container>
      {loading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: 10,
          backgroundColor: palette.background.default,
        }}
      >
        {error && <Typography color="error">{error}</Typography>}

        <Typography variant="h5" component="h2">
          Edit store
        </Typography>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "50%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {store && (
            <Form
              initialValues={{
                name: store.name,
                status: store.status,
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              <InputComponent label="name" />
              <RadioButtonComponent name={"status"} />
              <SubmitButton title={"Update store"} />
            </Form>
          )}
        </div>
      </Box>
    </Container>
  );
};

export default EditStore;
